import { GET_QUESTIONS_ANSWERS, SUBMIT_QUESTION_ANSWERS,GET_QUESTIONS } from './types';

/** Get */

export const getQuestionsAnswers = (questions) => ({
  type: GET_QUESTIONS_ANSWERS,
  payload: questions,
});
export const getQuestions = (questions) => ({
  type: GET_QUESTIONS,
  payload: questions,
});
export const submitQuestionAnswers = (questions) => ({
  type: SUBMIT_QUESTION_ANSWERS,
  payload: questions,
});
